<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <recargo-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import RecargoCrud from "./RecargoCrud";
    export default {
        name: "Recargo",
        components: {RecargoCrud}
    }
</script>

<style scoped>

</style>
